import { render } from "./UserPortrate.vue?vue&type=template&id=7c561c4c&scoped=true"
import script from "./UserPortrate.vue?vue&type=script&lang=js"
export * from "./UserPortrate.vue?vue&type=script&lang=js"

import "./UserPortrate.vue?vue&type=style&index=0&id=7c561c4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c561c4c"]])

export default __exports__